const NotificationActionTypes = {
  SET_NOTIFICATION_COUNT: 'SET_NOTIFICATION_COUNT',
  SET_NOTIFICATION_DISCUSSION: 'SET_NOTIFICATION_DISCUSSION',
  SET_NOTIFICATION_HIGHLIGHT: 'SET_NOTIFICATION_HIGHLIGHT',
  SET_NOTIFICATION_HELPCHAT: 'SET_NOTIFICATION_HELPCHAT',
};

export default NotificationActionTypes;
